import { FiChevronRight } from "react-icons/fi";
import { DocumentLink } from "../common/DocumentLink";
import { LeaguePlayerWithTeam } from "../../models/LeaguePlayer";
import { PlayerImage, TeamImage } from "../common/Images";
import { useTranslation } from "next-i18next";

interface PlayersListProps {
  players: LeaguePlayerWithTeam[];
  baseUrl: string;
  usePositionAsRank?: boolean;
}
export function PlayersList({
  players,
  baseUrl,
  usePositionAsRank = false,
}: PlayersListProps) {
  const { t } = useTranslation();
  return (
    <div className="container container-padding-responsive xl:rounded-md overflow-hidden">
      <div
        className="grid grid-cols-7 lg:grid-cols-8 px-4 text-gray-text bg-white max-lg:pt-4
      "
      >
        <div className="text-center">{t("Label_Rank")}</div>
        <div className="col-span-3 lg:col-span-2 max-lg:mr-2">
          {t("Player")}
        </div>
        <div className="max-lg:hidden col-span-2">{t("Label_Team")}</div>
        <div className="text-center">{t("Balance")}</div>
        <div className="text-center">+/-</div>
        <div />
      </div>

      {players.map((player, index) => (
        <PlayerCard
          key={player.id}
          player={player}
          baseUrl={baseUrl}
          rank={usePositionAsRank ? index + 1 : player.rank}
        />
      ))}
    </div>
  );
}

interface PlayerCardProps {
  player: LeaguePlayerWithTeam;
  baseUrl: string;
  rank: number;
}
function PlayerCard({ player, baseUrl, rank }: PlayerCardProps) {
  return (
    <DocumentLink
      href={`${baseUrl}/${player.id}`}
      className="bg-white items-center p-4 border-b border-gray-light group last:border-none lg:bg-bg-gray lg:rounded-lg grid grid-cols-7 lg:grid-cols-8 hover:text-black text-black lg:my-4 lg:border-none"
    >
      <div className="text-center">{rank}</div>
      <div className="flex gap-4 col-span-3 lg:col-span-2 items-center">
        <PlayerImage player={player.seasonPlayer} size="sm" />
        <div className="lg:text-xl truncate text-primary flex-1 max-lg:mr-2">
          {player.seasonPlayer.firstName} {player.seasonPlayer.lastName}
        </div>
      </div>
      <div className="max-lg:hidden flex gap-4 col-span-2 items-center">
        <TeamImage team={player.seasonPlayer.seasonTeam} />
        <div>{player.seasonPlayer.seasonTeam.name}</div>
      </div>
      <div className="text-center">
        {player.gameWins} : {player.gameLosses}
      </div>
      <div className="text-center">{player.gameWins - player.gameLosses}</div>
      <FiChevronRight className="ml-auto mr-4" />
    </DocumentLink>
  );
}
